import moment from 'moment';

export default class Batch {
  public batchid: string;
  public batchname: string;
  public cutoffdate: moment.Moment;
  public receivedatefrom: moment.Moment;
  public receivedateto: moment.Moment;
  public shipdate: moment.Moment;

  constructor() {
    this.batchid = '';
    this.batchname = '';
    this.cutoffdate = moment();
    this.receivedatefrom = moment();
    this.receivedateto = moment();
    this.shipdate = moment();
  }
}
